export default __webpack_public_path__ + "static/media/messageReminder16.7087ff96.svg";